import { ImageType } from "./IPicture";
/**
 * Picture object
 * Base64Image - encoded image
 * OwnerGuid - guid of owner (coud be user, device etc..)
 * OwnerIdentity - custom identifier to recognise images within the same GUID (channels of device, profile image of user, etc...).
 */
export class Picture {
    constructor() {
        this._guid = "";
        this._ownerGuid = "";
        this._ownerIdentity = "";
        this._base64Image = "";
        this._imageType = ImageType.Device;
        this._dateTime = "";
    }
    get Guid() {
        return this._guid;
    }
    get OwnerGuid() {
        return this._ownerGuid;
    }
    get OwnerIdentity() {
        return this._ownerIdentity;
    }
    get Base64Image() {
        return this._base64Image;
    }
    get ImageType() {
        return this._imageType;
    }
    get DateTime() {
        return this._dateTime;
    }
    set Base64Image(value) {
        this._base64Image = value;
    }
    set Guid(value) {
        this._guid = value;
    }
    set OwnerGuid(value) {
        this._ownerGuid = value;
    }
    set OwnerIdentity(value) {
        this._ownerIdentity = value;
    }
    set ImageType(value) {
        this._imageType = value;
    }
}
//# sourceMappingURL=Picture.js.map